import * as Actions from '../../actions';

const initialState = { data: null };

const producerDashboardLabReportReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_PRODUCER_DASHBOARD_LABREPORT_DETAILS:
            return { ...state, data: { ...action.payload } };

        default:
            return state;
    }
};

export default producerDashboardLabReportReducer;
